import React from "react";
import {
  Chip,
  FormControl,
  Grid,
  Select,
  Button,
  MenuItem,
} from "@mui/material";

import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material";
import { REPORT_SEVERITY_OPTIONS } from "static/constants";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import {
  resetAlertFilters,
  setAlertFilter,
  setDateFilter,
} from "app/store/transmission/slice/transmissionSlice";
import dayjs from "dayjs";

const PreviousAlertFilter = ({ isLoading }) => {
  const { alertFilter, dateFilter } = useSelector(
    (state) => state.transmission
  );

  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  return (
    <div
      className="report-note-popover-sub-header"
      style={{ marginTop: "10px" }}
    >
      <Grid
        direction="row"
        spacing={1}
        alignItems="center"
        style={{ margin: "0 8px" }}
      >
        <Chip
          size="small"
          variant="outlined"
          disabled={isLoading}
          style={{ marginRight: "4px" }}
          label={
            <div className="filter-button-wrapper">
              <div className="filter-button-wrapper-label">Alert:&nbsp;</div>
              <FormControl className="alert-dropdown">
                <Select
                  value={alertFilter}
                  onChange={(e) => dispatch(setAlertFilter(e.target.value))}
                  disableUnderline
                  displayEmpty
                  autoWidth
                  className="p-1"
                >
                  {REPORT_SEVERITY_OPTIONS?.map((option) => (
                    <MenuItem value={option}>{option}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          }
        />
        <Chip
          size="small"
          variant="outlined"
          disabled={isLoading}
          label={
            <div className="filter-button-wrapper">
              <div className="filter-button-wrapper-label">Date:&nbsp;</div>

              <DatePicker
                open={open}
                onClose={() => setOpen(false)}
                views={["year", "month"]}
                value={dateFilter === "All" ? null : dayjs(dateFilter)}
                placeholder="all"
                error={false}
                helperText={null}
                onAccept={(value) => {
                  dispatch(setDateFilter(dayjs(value).format("MMMM YYYY")));
                }}
                slots={{
                  openPickerIcon: () => <ArrowDropDownIcon />,
                }}
                className="previous-alert-date-picker"
                slotProps={{
                  inputAdornment: {
                    onClick: () => setOpen(true),
                  },
                  textField: {
                    inputProps: {
                      style: {
                        textAlign: "center",
                        padding: 0,
                      },
                    },

                    className: "date-picker__input--selected",
                    onClick: () => setOpen(true),
                  },
                }}
              />
            </div>
          }
        />
        {(alertFilter !== "All" || dateFilter !== "All") && (
          <Button
            variant="text"
            className="clear-filter-button"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(resetAlertFilters());
            }}
          >
            Clear Filters
          </Button>
        )}
      </Grid>
    </div>
  );
};

export default PreviousAlertFilter;
